var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.classnames},[_c('open-modal-control',{attrs:{"view":'modal-view-search',"props":{}}},[_c('VueButton',{attrs:{"direction":"rtl"}},[_c('template',{slot:"text"},[_vm._v("Search")]),_vm._v(" "),_c('template',{slot:"icon"},[_c('SvgIconSearch')],1)],2)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2e07dc01","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/js/components/ToolbarSearchButton.vue
// module id = vpyS
// module chunks = 1